export default __webpack_public_path__ + "static/media/10-znizki-desktop.80235c31.jpg";